import React from 'react';
import LazyLoad from 'react-lazyload';
import { string } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import useImage from '../../../../../hooks/useImage';

const SeoTabCard = ({ imgSrc, title, subtext, url }) => {
  const [img, updateImageUrl] = useImage(imgSrc);

  return (
    <a href={url}>
      <div className={styles.container}>
        <LazyLoad>
          <img src={img} alt="" onError={() => updateImageUrl()} className={styles.image} />
        </LazyLoad>
        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtext}>{subtext}</div>
        </div>
      </div>
    </a>
  );
};

SeoTabCard.propTypes = {
  imgSrc: string, // some trails don't have images
  title: string,
  subtext: string,
  url: string
};

SeoTabCard.defaultProps = {
  imgSrc: '',
  title: '',
  subtext: '',
  url: ''
};

export default SeoTabCard;
